import { customerAPI } from '../../services/CustomerServices';

export function fetchCustomers({
    currentPageNumber,
    itemsPerPage,
    searchPhrase,
    descending,
    orderByName,
    orderByOrdersQty,
}: {
    currentPageNumber: number;
    itemsPerPage: number;
    searchPhrase: string;
    descending: boolean;
    orderByName: boolean;
    orderByOrdersQty: boolean;
}) {
    const {
        data: customers,
        isLoading: getAllCustomersIsLoading,
        error: getAllCustomersError,
        isSuccess: getAllCustomersIsSuccess,
    } = customerAPI.useGetCustomersV2Query({
        page: currentPageNumber,
        pageSize: itemsPerPage,
        searchPhrase,
        descending,
        orderByName,
        orderByOrdersCount: orderByOrdersQty,
    });

    return {
        customers,
        getAllCustomersIsLoading,
        getAllCustomersError,
        getAllCustomersIsSuccess,
    };
}

export function updateCustomer() {
    const [updateItem, { error: updateCustomerError, isSuccess: updateCustomerIsSuccess }] = customerAPI.useUpdateCustomerV2Mutation();

    return {
        updateItem,
        updateCustomerError,
        updateCustomerIsSuccess,
    };
}

export function deleteCustomer() {
    const [deleteItem, { error: deleteCustomerError, isSuccess: deleteCustomerIsSuccess }] = customerAPI.useDeleteCustomerV2Mutation();

    return {
        deleteItem,
        deleteCustomerError,
        deleteCustomerIsSuccess,
    };
}

export function saveCustomer() {
    const [save, { error: saveCustomerError, isSuccess: saveCustomerIsSuccess }] = customerAPI.useUpdateCustomerV2Mutation();

    return {
        save,
        saveCustomerError,
        saveCustomerIsSuccess,
    };
}
